import countTo from 'vue-count-to';
export default {
  components: {
    countTo
  },
  props: {
    aggregate: {
      type: Array,
      default() {
        return [];
      }
    },
    panelData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  watch: {
    previewList: {
      handler(newArr) {
        this.timer1 = new Date().getTime();
      }
    },
    deep: true
  },
  data() {
    return {
      timer1: '0'
    };
  }
};